import { twMerge } from 'tailwind-merge';

interface TableCellProps {
  content: React.ReactNode;
  tdClassName?: string;
}

export const TableCell = ({ content, tdClassName }: TableCellProps) => {
  return (
    <td
      className={twMerge(
        'font-normal text-black-071336 dark-mode:text-gray-600',
        tdClassName,
      )}
    >
      {content}
    </td>
  );
};
